new MutationObserver(() => {
    document.querySelectorAll('span[role="button"]').forEach(el => {
        el.removeAttribute('role')
    });
    document.querySelectorAll('.announcement-slider__slide').forEach(el => {
        const isAriaHidden = el.getAttribute('aria-hidden') === 'true'
        if (isAriaHidden) {
            el.querySelectorAll('a').forEach((a) => {
                a.setAttribute('tabindex', -1);
            })
        } else {
            el.querySelectorAll('a').forEach((a) => {
                a.removeAttribute('tabindex');
            })
        }
    })
}).observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('span[role="button"]').forEach(el => {
    el.removeAttribute('role');
    el.removeAttribute('tabindex');
})

